(function(){
  function injectReadability(){
    var old=document.getElementById("rm-pdp-readability"); if(old)old.parentNode.removeChild(old);
    var rst=document.createElement("style"); rst.id="rm-pdp-readability";
    rst.textContent=".rm-pdp .subtitle{font-size:1.16rem !important;}.rm-pdp .usps li{font-size:1.1rem !important;}.rm-pdp .popt-title{font-size:1.12rem !important;}.rm-pdp .popt-sub{font-size:1.04rem !important;color:#4a5551 !important;}.rm-pdp .popt-price{font-size:1.3rem !important;}.rm-pdp .delivery{font-size:1.06rem !important;}.rm-pdp .assurances div{font-size:1.02rem !important;}.rm-pdp .crumbs{font-size:14.5px !important;}.rm-pdp .rating{font-size:15px !important;}.rm-pdp .acc-head{font-size:1.14rem !important;}.rm-pdp .pill{font-size:1.02rem !important;}.rm-pdp .ing-line,.rm-pdp .spec-row{font-size:1.06rem !important;}.rm-pdp .addon-head{font-size:1.2rem !important;}.rm-pdp .addon-name{font-size:1.08rem !important;}.rm-pdp .addon-desc{font-size:1rem !important;}.rm-pdp .story-body{font-size:1.16rem !important;}.rm-pdp .story-body p{font-size:1.16rem !important;}.rm-pdp .story-body .lead{font-size:1.28rem !important;}.rm-pdp .story-list li{font-size:1.12rem !important;}.rm-pdp .rv-text{font-size:1.1rem !important;}.rm-pdp .rv-author{font-size:1.04rem !important;}.rm-pdp .rv-verified{font-size:.92rem !important;}.rm-pdp .rv-date{font-size:14px !important;}.rm-pdp .faq-q{font-size:1.18rem !important;}.rm-pdp .faq-a p{font-size:1.12rem !important;}.rm-pdp .rf-toggle,.rm-pdp .rf-opt{font-size:16px !important;}";
    (document.body||document.head||document.documentElement).appendChild(rst);
  }
  injectReadability();

  function toCents(s){var p=s.split(",");return parseInt(p[0],10)*100+parseInt(p[1],10);}
  function fmt(c){var e=Math.floor(c/100),r=c%100;return ""+e+","+(r<10?"0"+r:r);}

  var root=document.querySelector(".rm-pdp");
  var P_ONCE=toCents("19,95");
  if(root){
    var rawPrice=parseFloat(root.getAttribute("data-price-once"));
    if(!isNaN(rawPrice)){ P_ONCE=Math.round(rawPrice*100); }
  }
  /* Spiegel van de automatische korting "3+ flessen massageolie = 15% korting"
     (Shopify admin > Kortingen), zelfde afronding als Shopify (korting per cent
     naar beneden). Wijzigt de korting in de admin, pas dan ook 0.15 hier aan. */
  var P_BUNDLE3=P_ONCE*3-Math.floor(P_ONCE*3*0.15);
  var variantId=root?root.getAttribute("data-variant-id"):null;

  var mode="once";
  var routinePlanId=null;
  /* Routineprijs komt uit de echte selling_plan_allocations (Seal), niet uit een
     gerekende -15%; routineCents volgt de gekozen frequentie. */
  var routineCents=P_ONCE;
  var planCents={};
  var qtyEl=document.getElementById("qty");
  var sQty=document.getElementById("sQty");
  var ctaPrice=document.getElementById("ctaPrice");
  var sCtaPrice=document.getElementById("sCtaPrice");
  var ctaLabel=document.getElementById("ctaLabel");
  var sCtaLabel=document.getElementById("sCtaLabel");
  var buyRow=document.querySelector(".buy");
  var stickyQty=document.querySelector(".sticky-qty");
  function getQty(){if(!qtyEl)return 1;var v=parseInt(qtyEl.value,10);if(isNaN(v)||v<1)v=1;return v;}
  function render(){
    var label="In winkelmand", priceText;
    if(mode==="routine"){ label="Routine starten"; priceText=fmt(routineCents); }
    else if(mode==="bundle3"){ priceText=fmt(P_BUNDLE3); }
    else { var q=getQty(); if(qtyEl)qtyEl.value=q; if(sQty)sQty.textContent=q; priceText=fmt(P_ONCE*q); }
    if(ctaPrice)ctaPrice.textContent=priceText; if(sCtaPrice)sCtaPrice.textContent=priceText;
    if(ctaLabel)ctaLabel.textContent=label; if(sCtaLabel)sCtaLabel.textContent=label;
    var rf=document.getElementById("routineFreq");
    if(rf)rf.hidden=(mode!=="routine");
    var hideQty=(mode!=="once");
    if(buyRow)buyRow.classList.toggle("qty-hidden",hideQty);
    if(stickyQty)stickyQty.style.display=hideQty?"none":"";
  }
  function bump(d){if(!qtyEl)return;qtyEl.value=Math.max(1,getQty()+d);render();}
  var minusBtn=document.getElementById("minus");
  if(minusBtn)minusBtn.addEventListener("click",function(){bump(-1);});
  var plusBtn=document.getElementById("plus");
  if(plusBtn)plusBtn.addEventListener("click",function(){bump(1);});
  var sM=document.getElementById("sMinus"),sP=document.getElementById("sPlus");
  if(sM)sM.addEventListener("click",function(){bump(-1);});
  if(sP)sP.addEventListener("click",function(){bump(1);});
  if(qtyEl)qtyEl.addEventListener("input",render);
  function selectMode(opt){
    document.querySelectorAll("#purchaseOpts .popt").forEach(function(x){x.classList.remove("selected");x.setAttribute("aria-checked","false");});
    opt.classList.add("selected"); opt.setAttribute("aria-checked","true");
    mode=opt.getAttribute("data-mode");
    /* Het bundelaantal mag niet blijven hangen in andere modi: alleen
       bundle3 zet 3, elke andere keuze begint weer op 1. */
    if(mode==="bundle3"){ if(qtyEl)qtyEl.value=3; }
    else { if(qtyEl)qtyEl.value=1; }
    render();
  }
  document.querySelectorAll("#purchaseOpts .popt").forEach(function(opt){
    opt.addEventListener("click",function(){ selectMode(opt); });
  });
  render();

  function injectRoutine(plans){
    if(!plans.length) return;
    var opts=document.getElementById("purchaseOpts");
    var onceBtn=opts?opts.querySelector('.popt[data-mode="once"]'):null;
    if(!opts||!onceBtn) return;
    if(!document.getElementById("rm-routine-style")){
      var st=document.createElement("style"); st.id="rm-routine-style";
      st.textContent=".popt-routine{display:block !important;}"
        +".popt-routine .popt-row{display:flex;align-items:center;gap:12px;width:100%;}"
        +".popt-routine .popt-main{flex:1;min-width:0;text-align:left;}"
        +".popt-save{display:inline-block;background:#a97e35;color:#fff;font-size:10.5px;font-weight:700;letter-spacing:.04em;padding:2px 7px;border-radius:6px;vertical-align:middle;margin-left:6px;}"
        +".popt-was{display:block;font-size:.78em;font-weight:400;color:#b6b0a4;text-decoration:line-through;margin-top:2px;}"
        +".routine-freq{margin-top:14px;position:relative;}"
        +".rf-toggle{width:100%;display:flex;align-items:center;justify-content:space-between;gap:10px;font-family:inherit;font-weight:600;color:#2d4947;background:#fff;border:1px solid #ddd6c6;border-radius:12px;padding:13px 16px;cursor:pointer;}"
        +".rf-chev{width:16px;height:16px;flex:none;color:#a97e35;transition:transform .2s ease;}"
        +".rf-toggle[aria-expanded=\"true\"] .rf-chev{transform:rotate(180deg);}"
        +".rf-menu{position:absolute;left:0;right:0;top:calc(100% + 6px);z-index:40;background:#fff;border:1px solid #ece7dd;border-radius:12px;box-shadow:0 18px 44px -18px rgba(45,73,71,.45);padding:6px;}"
        +".rf-opt{display:flex;align-items:center;justify-content:space-between;width:100%;text-align:left;font-family:inherit;font-weight:500;color:#2d4947;background:none;border:none;border-radius:8px;padding:12px 12px;cursor:pointer;}"
        +".rf-opt:hover{background:#f6f1e8;}"
        +".rf-opt[aria-selected=\"true\"]{color:#a97e35;font-weight:600;}"
        +".rf-opt[aria-selected=\"true\"]:after{content:'\\2713';color:#a97e35;font-weight:700;}";
      document.head.appendChild(st);
    }
    routinePlanId=plans[0].id;
    plans.forEach(function(p){planCents[p.id]=p.cents;});
    routineCents=planCents[routinePlanId]||P_ONCE;
    function badgeHtml(c){var saving=P_ONCE-c;var pct=P_ONCE>0&&saving>0?Math.round(saving*100/P_ONCE):0;return pct>0?' <span class="popt-save">−'+pct+'%</span>':'';}
    var menuHtml='';
    plans.forEach(function(p,i){ menuHtml+='<button type="button" class="rf-opt" role="option" data-id="'+p.id+'" aria-selected="'+(i===0?"true":"false")+'">'+p.name+'</button>'; });
    var div=document.createElement("div");
    div.className="popt popt-routine"; div.setAttribute("role","radio"); div.setAttribute("aria-checked","false"); div.setAttribute("data-mode","routine");
    div.innerHTML='<div class="popt-row"><span class="popt-radio"></span>'
      +'<span class="popt-main"><span class="popt-title">Routine<span id="rmRoutineSave">'+badgeHtml(routineCents)+'</span></span>'
      +'<span class="popt-sub">Pauzeren of annuleren wanneer je wilt</span></span>'
      +'<span class="popt-price"><span id="rmRoutinePrice">'+fmt(routineCents)+'</span><span class="popt-was">'+fmt(P_ONCE)+'</span></span></div>'
      +'<div class="routine-freq" id="routineFreq" hidden>'
      +'<button type="button" class="rf-toggle" id="rfToggle" aria-haspopup="listbox" aria-expanded="false"><span id="rfLabel">'+plans[0].name+'</span><svg class="rf-chev" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M6 9l6 6 6-6"/></svg></button>'
      +'<div class="rf-menu" id="rfMenu" role="listbox" hidden>'+menuHtml+'</div>'
      +'</div>';
    onceBtn.insertAdjacentElement("afterend",div);
    div.addEventListener("click",function(){ selectMode(div); });
    var rfToggle=document.getElementById("rfToggle");
    var rfMenu=document.getElementById("rfMenu");
    var rfLabel=document.getElementById("rfLabel");
    if(rfToggle&&rfMenu){
      rfToggle.addEventListener("click",function(e){
        e.stopPropagation();
        var willOpen=rfMenu.hidden;
        rfMenu.hidden=!willOpen;
        rfToggle.setAttribute("aria-expanded",willOpen?"true":"false");
      });
      div.querySelectorAll(".rf-opt").forEach(function(o){
        o.addEventListener("click",function(e){
          e.stopPropagation();
          routinePlanId=o.getAttribute("data-id");
          routineCents=planCents[routinePlanId]||P_ONCE;
          var priceEl=document.getElementById("rmRoutinePrice");if(priceEl)priceEl.textContent=fmt(routineCents);
          var saveEl=document.getElementById("rmRoutineSave");if(saveEl)saveEl.innerHTML=badgeHtml(routineCents);
          if(rfLabel)rfLabel.textContent=o.textContent;
          div.querySelectorAll(".rf-opt").forEach(function(x){x.setAttribute("aria-selected","false");});
          o.setAttribute("aria-selected","true");
          rfMenu.hidden=true; rfToggle.setAttribute("aria-expanded","false");
          if(mode==="routine")render();
        });
      });
      document.addEventListener("click",function(){ if(!rfMenu.hidden){ rfMenu.hidden=true; rfToggle.setAttribute("aria-expanded","false"); } });
    }
  }
  fetch(location.pathname.replace(/\/$/,"")+".js",{headers:{"Accept":"application/json"}})
    .then(function(r){ return r.ok?r.json():null; })
    .then(function(data){
      if(!data||!data.selling_plan_groups) return;
      var vid=Number(variantId);
      var variant=(data.variants||[]).filter(function(v){return v.id===vid;})[0]||(data.variants||[])[0];
      var allocs=(variant&&variant.selling_plan_allocations)||[];
      var names={};
      data.selling_plan_groups.forEach(function(g){
        (g.selling_plans||[]).forEach(function(p){ names[p.id]=(p.name||"").trim(); });
      });
      var plans=[], seen={};
      allocs.forEach(function(a){
        var nm=names[a.selling_plan_id]||"Elke levering";
        if(!seen[nm]){ seen[nm]=1; plans.push({id:a.selling_plan_id,name:nm,cents:a.price}); }
      });
      injectRoutine(plans);
    }).catch(function(){});

  var bar=document.getElementById("stickyBar");
  var mainCta=document.getElementById("cta");
  if(bar&&mainCta){
    var syncBar=function(){var r=mainCta.getBoundingClientRect();bar.classList.toggle("show",r.bottom<0);};
    window.addEventListener("scroll",syncBar,{passive:true});
    window.addEventListener("resize",syncBar);
    syncBar();
  }

  document.querySelectorAll(".acc-head").forEach(function(h){
    h.addEventListener("click",function(){h.parentElement.classList.toggle("open");});
  });

  var rm=document.getElementById("readmore");
  if(rm){rm.addEventListener("click",function(){
    var more=document.getElementById("storyMore");
    var open=more.classList.toggle("open");
    rm.querySelector(".pm").textContent=open?"–":"+";
    rm.querySelector(".rt").textContent=open?"Lees minder":"Lees het hele verhaal";
  });}

  document.querySelectorAll("#thumbs .thumb").forEach(function(t){
    t.addEventListener("click",function(){
      document.querySelectorAll("#thumbs .thumb").forEach(function(x){x.classList.remove("active");});
      t.classList.add("active");
      var hero=document.getElementById("heroImg");
      if(hero)hero.src=t.dataset.full;
    });
  });

  var car=document.getElementById("carousel");
  var carPrev=document.getElementById("carPrev");
  if(carPrev&&car)carPrev.addEventListener("click",function(){car.scrollBy({left:-280,behavior:"smooth"});});
  var carNext=document.getElementById("carNext");
  if(carNext&&car)carNext.addEventListener("click",function(){car.scrollBy({left:280,behavior:"smooth"});});

  /* Extra's (Maak je ritueel compleet) en carrouselkaarten voegen het product
     echt toe aan de winkelmand, zelfde patroon als de losse PDP-secties.
     De handle komt uit data-handle op de knop of uit de productlink van de
     kaart; daarna bepaalt products/<handle>.js de eerste leverbare variant. */
  function handleFor(btn){
    if(btn.dataset.handle)return btn.dataset.handle;
    var card=btn.closest(".card"),a=card&&card.querySelector(".card-imglink");
    if(a){var h=a.getAttribute("href")||"",i=h.indexOf("/products/");if(i>=0)return h.slice(i+10);}
    return null;
  }
  document.querySelectorAll(".card-add, .addon-btn").forEach(function(b){
    b.addEventListener("click",function(e){
      e.preventDefault();e.stopPropagation();
      if(b.dataset.busy)return;
      var handle=handleFor(b);
      if(!handle)return;
      var isCard=b.classList.contains("card-add");
      b.dataset.busy="1";
      var prev=b.textContent;
      b.textContent=isCard?"…":"Bezig…";
      fetch("/products/"+handle+".js",{headers:{Accept:"application/json"}})
        .then(function(r){return r.json();})
        .then(function(prod){
          var vr=(prod.variants||[]).filter(function(x){return x.available;})[0]||prod.variants[0];
          if(!vr)throw "geen variant";
          return fetch("/cart/add.js",{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({items:[{id:vr.id,quantity:1}]})})
            .then(function(r){if(!r.ok)throw "add "+r.status;});
        })
        .then(function(){
          delete b.dataset.busy;
          if(isCard){var card=b.closest(".card");if(card)card.classList.add("added-card");b.classList.add("added");b.textContent="✓";}
          else{b.classList.add("added");b.textContent="✓ Toegevoegd";}
        })
        .catch(function(){delete b.dataset.busy;b.textContent=prev;alert("Toevoegen is niet gelukt. Probeer het opnieuw.");});
    });
  });

  function addToCart(btn){
    var t=btn.innerHTML;
    btn.innerHTML="✓ Toegevoegd aan winkelmand";
    var body;
    if(mode==="routine" && routinePlanId){
      body={ id: variantId, quantity: 1, selling_plan: routinePlanId };
    } else {
      var quantity=(mode==="bundle3") ? 3 : getQty();
      body={ id: variantId, quantity: quantity };
    }
    var done=function(){ window.location.href="/cart"; };
    if(variantId){
      fetch('/cart/add.js',{
        method:'POST',
        headers:{'Content-Type':'application/json'},
        body:JSON.stringify(body)
      }).then(function(){ setTimeout(done,600); }).catch(function(){ setTimeout(function(){ btn.innerHTML=t; },600); });
    } else {
      setTimeout(function(){ btn.innerHTML=t; },1400);
    }
  }
  var ctaBtn=document.getElementById("cta");
  if(ctaBtn)ctaBtn.addEventListener("click",function(){addToCart(this);});
  var sc=document.getElementById("sCta");
  if(sc)sc.addEventListener("click",function(){addToCart(this);});

  (function(){
    var grid=document.getElementById("rvGrid");
    if(!grid)return;
    var wrap=document.getElementById("rvWrap");
    var empty=document.getElementById("rvEmpty");
    var moreWrap=document.getElementById("rvMore");
    var moreBtn=moreWrap?moreWrap.querySelector("button"):null;
    var collapsedMax=430;
    var btns=[].slice.call(document.querySelectorAll("#rvFilters .rv-filter"));
    var cards=[].slice.call(grid.querySelectorAll(".rv-card"));
    function syncMore(){
      var collapsed=wrap.classList.contains("collapsed");
      grid.style.maxHeight="none";
      var nat=grid.scrollHeight;
      grid.style.maxHeight="";
      var over=nat>collapsedMax+12;
      wrap.classList.toggle("faded",collapsed&&over);
      if(moreWrap)moreWrap.style.display=over?"flex":"none";
      if(moreBtn){
        moreBtn.querySelector(".pm").textContent=collapsed?"+":"–";
        moreBtn.querySelector(".rt").textContent=collapsed?"Toon meer reviews":"Toon minder";
      }
    }
    function apply(f){
      var n=0;
      cards.forEach(function(c){
        var show=(f==="all"||c.getAttribute("data-stars")===f);
        c.style.display=show?"":"none";
        if(show)n++;
      });
      if(empty)empty.style.display=n?"none":"block";
      syncMore();
    }
    btns.forEach(function(b){
      b.addEventListener("click",function(){
        btns.forEach(function(x){x.classList.remove("active");});
        b.classList.add("active");
        apply(b.getAttribute("data-filter"));
      });
    });
    if(moreBtn)moreBtn.addEventListener("click",function(){
      wrap.classList.toggle("collapsed");
      syncMore();
    });
    window.addEventListener("resize",syncMore);
    syncMore();
  })();

  (function(){
    var items=[].slice.call(document.querySelectorAll("#faqList .faq-item"));
    items.forEach(function(it){
      var q=it.querySelector(".faq-q");
      q.addEventListener("click",function(){
        var open=it.classList.toggle("open");
        q.setAttribute("aria-expanded",open?"true":"false");
      });
    });
  })();
})();
